<template>
  <div id="app">
    <div v-if="$auth.ready()">
      <div v-if="$router.currentRoute.name !== 'report.embed'">
        <header-component v-if="$auth.check()" />
        <sideBar-component v-if="$auth.check()" />
        <div
          v-if="$auth.check()"
          class="content-wrapper">
          <verified-email />
          <router-view />
        </div>
        <home-component v-if="!$auth.check()" />
      </div>
      <div v-else>
        <report-embed :report_id="$route.params.report_id" />
      </div>
    </div>
    <div v-if="!$auth.ready()">
      <spinner-component style="margin-top: 45vh" />
    </div>
  </div>
</template>

<script>
  import ReportEmbed from "./views/reports/embed/Embed.vue";
  import HeaderComponent from "./components/Header.vue";
  import SideBarComponent from "./components/SideBar.vue";
  import HomeComponent from "./components/Home.vue";
  import VerifiedEmail from "./components/VerifiedEmail.vue";
  import SpinnerComponent from "./components/Spinner-loader.vue"

  export default {
    components: {
      HeaderComponent,
      SideBarComponent,
      HomeComponent,
      ReportEmbed,
      VerifiedEmail,
      SpinnerComponent,
    }
  };
</script>

<style lang="scss">
   @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
   @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
